import React from 'react';
import Radio from '@mui/material/Radio';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

const RolesPicker = ({ availableRoles, selectedRoleId, onChange }) => {
    return (
        <List>
            {availableRoles.map(({ id, name, description }) => (
                <ListItem
                    key={id}
                    dense
                    disableGutters
                    disablePadding
                >
                    <ListItemButton onClick={() => onChange(id)} selected={selectedRoleId === id}>
                        <ListItemIcon>
                            <Radio
                                edge="start"
                                disableRipple
                                checked={selectedRoleId === id}
                            />
                        </ListItemIcon>
                        <ListItemText
                            primary={name}
                            secondary={description}
                        />
                    </ListItemButton>
                </ListItem>
            ))}
        </List>
    );
};

export default RolesPicker;
